import { useEffect, useState, useRef } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import sharedStyles from 'styles/css/SharedStyles.module.scss';
import styles from 'styles/css/Main.module.scss';
import drawerStyles from 'styles/css/Drawer.module.scss';
import actionStyles from 'styles/css/ActionStyles.module.scss';
import Logo from 'styles/images/logo/logo512.png';
import Instagram from 'styles/images/svg/instagram.svg';
import LinkedIn from 'styles/images/svg/linkedin.svg';
import YouTube from 'styles/images/svg/youtube.svg';
import Facebook from 'styles/images/svg/facebook.svg';
import ForwardIcon from 'styles/images/svg/forward-white.svg';
import ArrowUp from 'styles/images/svg/arrow-up.svg';
import ArrowDown from 'styles/images/svg/arrow-down.svg';
import ChatIcon from 'styles/images/svg/chat.svg';
import { API_MAIN, USERS_LOGOUT_GET, API_UNREAD_MSG_COUNT } from 'apis';
import apiRequest from 'utils/apiRequest';
import { handleChangeDataPageMain } from 'reduxx/actions/pages/main';
import { actionLogOutUser } from 'reduxx/actions/pages/user/login';
import { handleChangeDataSurguryConsultationPage } from "reduxx/actions/pages/surguryConsultation";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import Swal from 'sweetalert2';
import Org1 from 'styles/images/logo/org-1.png';
import Org2 from 'styles/images/logo/org-2.png';
import Org3 from 'styles/images/logo/org-3.png';
import Org4 from 'styles/images/logo/org-4.png';
import Enamad from 'styles/images/logo/enamad-81.png';

const Main = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { token, profile } = useSelector(state => state.login);
    const { mainSlider, adsSlider, features, isDrawerOpen, unreadMsgCount } = useSelector(state => state.main);

    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 8); // آستانه تغییر حالت هدر
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    useEffect(() => {
        if(mainSlider.length === 0)
            apiMain();
        else if(!! token)
            apiUnreadMessages();
    }, []);

    const apiMain = () => {
        apiRequest({
            dispatch,
            endpoint: API_MAIN,
            method: 'post',
            data: {width: window.innerWidth},
            ...(token && { token }),
            successMessage: null,
            onSuccess: (res) => {
                dispatch(handleChangeDataPageMain('mainSlider', res.mainSlider));
                dispatch(handleChangeDataPageMain('adsSlider', res.adsSlider));
                dispatch(handleChangeDataPageMain('features', res.features));
                dispatch(handleChangeDataPageMain('unreadMsgCount', res.unreadMsgCount));
            }
        });
    };

    const apiUnreadMessages = () => {
        apiRequest({
            dispatch,
            endpoint: API_UNREAD_MSG_COUNT,
            method: 'post',
            data: {width: window.innerWidth},
            token: token,
            successMessage: null,
            onSuccess: (res) => {
                dispatch(handleChangeDataPageMain('unreadMsgCount', res.unreadMsgCount));
            }
        });
    };


    const handleOnlineVisit = () => {
        // if(!token)
        //     navigate('login');
        // else {
        //     if(profile.medicalRecords.insurance === null || profile.nationalCode === null || profile.medicalRecords.hasSpecialDisease === null)
        //         navigate('medical-record');
        //     else if(profile.medicalRecords.hasSpecialMedication === null)
        //         navigate('medical-record2');
        //     else if(profile.medicalRecords.hasDrugAllergy === null)
        //         navigate('medical-record3');
        //     else
        //         navigate('visit-req');
        // }
        navigate('visit-req');
    };

    const navigateToConsultation = (onlyForm) => {
        dispatch(handleChangeDataSurguryConsultationPage('onlyForm', onlyForm));
        navigate(`/surgury-consultation`);
    }


    // const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const toggleDrawer = () => {
        // setIsDrawerOpen(!isDrawerOpen);
        dispatch(handleChangeDataPageMain('isDrawerOpen', !isDrawerOpen));
    };
    const closeDrawer = () => {
        // setIsDrawerOpen(!isDrawerOpen);
        dispatch(handleChangeDataPageMain('isDrawerOpen', false));
    };

    const [isAboutOpen, setIsAboutOpen] = useState(false);
    const toggleAbout = () => setIsAboutOpen((prev) => !prev);

    const drawerRef = useRef(null);
    const touchStartX = useRef(null);
    const touchCurrentX = useRef(null);

    // بستن Drawer با کلیک خارج
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isDrawerOpen && drawerRef.current && !drawerRef.current.contains(event.target)) {
                // setIsDrawerOpen(false);
                dispatch(handleChangeDataPageMain('isDrawerOpen', !isDrawerOpen));
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isDrawerOpen]);

    useEffect(() => {
        if (isDrawerOpen) {
            document.body.style.overflow = "hidden"; // قفل کردن اسکرول
        } else {
            document.body.style.overflow = "auto"; // آزاد کردن اسکرول
        }

        return () => {
            document.body.style.overflow = "auto";
        };
    }, [isDrawerOpen]);


    // مدیریت رویدادهای لمسی برای کشیدن
    const handleTouchStart = (e) => {
        touchStartX.current = e.touches[0].clientX;
        touchCurrentX.current = touchStartX.current;
    };

    const handleTouchMove = (e) => {
        touchCurrentX.current = e.touches[0].clientX;
        const deltaX = touchCurrentX.current - touchStartX.current;
        if (deltaX > 0 && drawerRef.current) {
            drawerRef.current.style.transform = `translateX(${Math.max(0, deltaX)}px)`;
        }
    };

    const handleTouchEnd = () => {
        const deltaX = touchCurrentX.current - touchStartX.current;
        if (deltaX > 50) { // اگه بیشتر از 50px به چپ کشیده شد، Drawer بسته بشه
            // setIsDrawerOpen(false);
            dispatch(handleChangeDataPageMain('isDrawerOpen', !isDrawerOpen));
        }
        if (drawerRef.current) {
            drawerRef.current.style.transform = ''; // بازگرداندن به حالت پیش‌فرض
        }
        touchStartX.current = null;
        touchCurrentX.current = null;
    };

    const handleLogOut = () => {
        toggleDrawer();

        if(token) {
            const buttonsOkCancel = Swal.mixin({
                customClass: {
                    confirmButton: actionStyles['btn-accept'],
                    cancelButton: [actionStyles['btn-cancel'], actionStyles['mr-12']].join(' '),
                },
                buttonsStyling: false
            });

            buttonsOkCancel.fire({
                text: "آیا میخواهید از حساب کاربری خود خارج شوید؟",
                imageUrl: Logo,
                imageHeight: 80,
                imageAlt: 'دکتر20',
                confirmButtonText: "بله",
                showCancelButton: true,
                cancelButtonText: 'انصراف',
            }).then((result) => {
                if (result.isConfirmed) {
                    apiRequest({
                        dispatch,
                        endpoint: USERS_LOGOUT_GET,
                        method: 'get',
                        ...(token && { token }),
                        successMessage: 'با موفقیت از حساب کاربری خارج شدید.',
                        onSuccess: (res) => {
                            dispatch(actionLogOutUser());
                        }
                    });
                }
            }); 
        }
            
    };


    const handleClickMajazi = () => {
        window.open(
            'https://ecunion.ir/verify/dr20.org?token=377724768d1108f9f46f',
            'Popup',
            'toolbar=no,location=no,statusbar=no,menubar=no,scrollbars=1,resizable=0,width=580,height=600,top=30'
        );
    };

    const toPersianDigits = (num) => {
        return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
    };

    return (
        
        <div className={[sharedStyles.container, scrolled ? sharedStyles.scrolled : ''].join(' ')}>
            {/* <header className={[styles.header, scrolled ? styles['header--sticky'] : ''].join(' ')}> */}
            <header className={[styles.header, styles['header--sticky']].join(' ')}>
                <div className={[sharedStyles.flex, sharedStyles.itemsCenter, sharedStyles['gapLg']].join(' ')}>
                    <button className={styles['menu-btn']} aria-label="menu" onClick={toggleDrawer}>
                        <span />
                        <span />
                        <span />
                    </button>
                    <Link to={`/visit-history`} style={{position: "relative"}}>
                        <img src={ChatIcon} height={33} style={{verticalAlign: 'middle'}} />
                        { unreadMsgCount > 0 &&
                        <span style={{backgroundColor: "red", color: "white", position: "absolute", width: "20px", height: "20px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "small", top: "0px", left: "0px", transform: "translateY(-40%) translateX(-40%)"}}>
                            {toPersianDigits(unreadMsgCount)}
                        </span>
                        }
                    </Link>
                </div>
                    
                <div className={styles.logo}>
                    <img src={Logo} alt="دکتر20" />
                </div>
            </header>

            <section className={styles.hero} >
                <Swiper
                    modules={[Pagination, Autoplay]}
                    spaceBetween={0}
                    slidesPerView={1}
                    // pagination={{ clickable: true }}
                    // navigation={true}
                    pagination={false}
                    autoplay={{ delay: 5000, disableOnInteraction: false }}
                    className={styles.swiper}
                >
                    {mainSlider.map((slide, index) => (
                        <SwiperSlide key={index}>
                            <div className={styles.slide} style={{ backgroundImage: `url(${slide.image})` }}></div>
                        </SwiperSlide>
                    ))}
                </Swiper>

                {/*<button onClick={handleOnlineVisit} className={styles['cta-btn']}>درخواست ویزیت آنلاین</button>*/}
                <div className={[sharedStyles.flex, sharedStyles['flex-col'], styles['cta-div']].join(' ')}>
                    <button onClick={handleOnlineVisit} className={styles['cta-btn']} style={{bottom: '75px'}}>درخواست ویزیت آنلاین</button>
                    <button onClick={() => navigateToConsultation(true)} className={styles['cta-btn']}>درخواست مشاوره اعمال جراحی</button>
                </div>
                
            </section>

            {isDrawerOpen && (
                <div className={drawerStyles.overlay} onClick={toggleDrawer}></div>
            )}
            <div 
                    ref={drawerRef} 
                    onTouchStart={handleTouchStart} 
                    onTouchMove={handleTouchMove}
                    onTouchEnd={handleTouchEnd}
                    className={`${drawerStyles.drawer} ${isDrawerOpen ? drawerStyles['drawer--open'] : ''}`}>
                <div className={drawerStyles.header}>
                    <img src={Logo} height={60} alt="دکتر20" />

                    <button className={drawerStyles['close-btn']} onClick={closeDrawer}>
                        ✕
                    </button>
                </div>
                    
                <nav className={drawerStyles['drawer-nav']}>
                    <ul className={sharedStyles['pb-[32px]']}>
                        <li><Link to={`/edit-profile`}>اطلاعات کاربری</Link></li>
                        <li><Link to={`/about-us/activities`}>فیلدهای فعالیت Dr20</Link></li>
                        <li><Link to={`/medical-record`}>پرونده پزشکی الکترونیک</Link></li>
                        <li><Link to={`/visit-fee`}>نرخ ویزیت دکتربیست</Link></li>
                        <li><Link onClick={() => dispatch(handleChangeDataSurguryConsultationPage('onlyForm', false))} to={`/surgury-consultation`}>درخواست مشاوره اعمال جراحی</Link></li>
                        <li><Link to={`/vip-services`} >خدمات VIP</Link></li>
                        {/*<li><Link to={`/discounts`}>تخفیفات ویژه Dr20</Link></li>*/}
                        <li><Link to={`/elite-doctors-membership`}>فرم عضویت پزشکان نخبه</Link></li>
                        <li><Link to={`/future-projects`}>پروژه‌های آینده دکتر بیست</Link></li>
                        <li><Link to={`/investment`}>فرصت سرمایه گذاری</Link></li>
                        <li><Link to={`/suggestions`}>پیشنهادات و نظرات</Link></li>
                        <li><Link to={`/rules`}>قوانین و مقررات</Link></li>
                        
                        <li
                            className={`${drawerStyles["menu-item-with-sub"]} ${
                              isAboutOpen ? drawerStyles["open"] : ""
                            }`}
                          >
                            <button className={drawerStyles["submenu-toggle"]} onClick={toggleAbout}>
                                درباره ما
                                <span className={drawerStyles.arrow}>
                                    <img src={ArrowDown} />
                                </span>
                            </button>
                            {isAboutOpen && (
                                <ul className={drawerStyles.submenu}>
                                    <li><Link to={`/about-us/naming-reason`}>علت نامگذاری دکتر بیست</Link></li>
                                    {/*<li><Link to={`/about-us/bylaws`}>کلیات اساس نامه</Link></li>*/}
                                    {/*<li><Link to={`/about-us/activities`}>فیلدهای فعالیت Dr20</Link></li>*/}
                                    <li><Link to={`/about-us/ceo-resume`}>رزومه مدیر‌عامل</Link></li>
                                </ul>
                            )}
                        </li>
                        <li><Link to={`/contact-us`}>ارتباط با ما</Link></li>
                        { token &&
                        <li><Link onClick={handleLogOut}>خروج</Link></li>
                        }
                    </ul>
                </nav>
            </div>


            <section className={styles.intro}>
                <h1>
                    دسترسی <span className={styles.highlight}>سریع</span> و   <span className={styles.highlight}>آسان</span>
                    <br />
                     به  <span className={styles.highlight}>پزشکان  نخبه و منتخب </span>
                        <br />
                     دکتر بیست (Dr20)
                </h1>
            </section>

            <section className={styles['content-card']}>
                {
                    adsSlider.map((ads, key) => (
                        <div className={styles['card-inner']}>
                            <div className={styles['placeholder-img']}>
                                <img src={ads.image} alt={ads.title} />
                            </div>
                            <div className={styles.note}>
                                <span>{ads.title}</span>
                                <button onClick={handleOnlineVisit} className={styles['back-btn']}>
                                    <img src={ForwardIcon} width={20} />
                                </button>
                            </div>
                            
                        </div>
                    ))
                }
                
            </section>

            <section className={styles.features}>
                {
                    features.map((feature, key) => (
                        <div key={`features-${key}`}>
                            <img src={feature.image} alt={feature.title} />
                            <span>{feature.title}</span>
                        </div>
                    ))
                }

                <button onClick={handleOnlineVisit} className={[styles['cta-full'], styles['mt-24']].join(' ')}>درخواست ویزیت - نسخه الکترونیک</button>
            </section>

            <footer className={styles.footer}>
                
                <div className={styles.socials}>
                    <a href="https://www.who.int/" target="_blank"><img src={Org1} width={48} /></a>
                    <a href="https://behdasht.gov.ir/" target="_blank" title="وزارت بهداشت، درمان و آموزش پزشكي"><img src={Org4} width={48} /></a>
                    <a href="https://sums.ac.ir/" target="_blank" title="دانشگاه علوم پزشکی و خدمات بهداشتی درمانی شیراز"><img src={Org3} width={48} /></a>
                    <a href="https://fa.shirazmc.com/" target="_blank" title="سازمان نظام پزشکی شیراز"><img src={Org2} width={48} /></a>
                </div>

                <div className={styles['contact-us']}>
                    آدرس دفتر:
                    <br />
                    شیراز، بلوار میرزای شیرازی(تاچارا)،بلوار بهشت، مجتمع تجاری ارکیده، واحد 18
                </div>

                <div className={styles.socials}>
                    <a href="https://instagram.com/dr20_org"><img src={Instagram} width={48} /></a>
                    <a href="#"><img src={LinkedIn} width={48} /></a>
                    <a href="#"><img src={YouTube} width={48} /></a>
                    <a href="#"><img src={Facebook} width={48} /></a>
                </div>

                <div className={styles['contact-us']}>
                    راه‌های ارتباطی:
                    <br />
                    {/*071-36364893 (6 خط تلفن سانترال)*/}
                    <div className={[sharedStyles.flex, sharedStyles.justifyCenter].join(' ')}>
                    	<div className={[sharedStyles.flex, sharedStyles['flex-col'], sharedStyles.itemsEnd, sharedStyles['w-fit']].join(' ')}>
	                    	{/*<span className={[sharedStyles['dir-ltr'], sharedStyles['w-full'], sharedStyles.flex, sharedStyles.justifyBetween, sharedStyles.gapLg].join(' ')}>
	                    		<a href="tel:35017" style={{textDecoration: "none", color: "unset"}}>35017</a> <span className={sharedStyles['dir-rtl']}>({toPersianDigits("30")} خط تلفن ثابت)</span>
	                    	</span>
		                    <a href="tel:+987136242214" style={{textDecoration: "none", color: "unset"}}>07136242214</a>*/}

                            <span className={[sharedStyles['dir-ltr'], sharedStyles['w-full'], sharedStyles.flex, sharedStyles.justifyBetween, sharedStyles.gapLg].join(' ')}>
                                <a href="tel:+987136242214" style={{textDecoration: "none", color: "unset"}}>07136242214</a> <span className={sharedStyles['dir-rtl']}>({toPersianDigits("7")} خط سانترال)</span>
                            </span>

		                    <span className={[sharedStyles['dir-ltr'], sharedStyles['w-full'], sharedStyles.flex, sharedStyles.justifyBetween, sharedStyles.gapLg].join(' ')}>
		                    	{/*<a href="https://wa.me/+989020843320" style={{textDecoration: "none", color: "unset"}}>09020843320</a> (واتس‌اپ، روبیکا، بله، ایتا)*/}
                                {/*<a href="https://rubika.ir/dr20_org" style={{textDecoration: "none", color: "unset"}}>09020843320</a> (واتس‌اپ، روبیکا، بله، ایتا)*/}
                                <a href="https://rubika.ir/dr20_org" style={{textDecoration: "none", color: "unset"}}>09171020676 </a> (واتس‌اپ، روبیکا، بله، ایتا)
		                    </span>
	                    </div>
                    </div>
	                    
	                    
                    {/*09020843320 (واتس‌اپ، روبیکا، بله، ایتا)
                    <br />*/}
                    همه روزه 8صبح تا 8 شب
                    <br />
                    حتی ایام تعطیلات رسمی
                </div>

                <div style={{display: 'flex', justifyContent: 'center', gap: '32px', marginTop: '24px'}}>
                    {/*<a
                        href="https://trustseal.enamad.ir/?id=692427&Code=Q1wfEpgiPPY3VshzsNkoLjA2T5Aq0fVL"
                        target="_blank"
                        style={{ display: "flex", alignItems: 'center', justifyContent: 'end' }}
                    >
                        <img
                            src={Enamad}
                            alt="Enamad"
                            style={{ cursor: "pointer", height: '100%', width: 'auto', maxHeight: '144px', display: 'block' }}
                            code='Q1wfEpgiPPY3VshzsNkoLjA2T5Aq0fVL'
                        />
                    </a>*/}
                    <a
                        href="https://trustseal.enamad.ir/?id=716867&Code=lpcM4Lnx6MYjfARckKsZYvDWyQcovZDS"
                        target="_blank"
                        style={{ display: "flex", alignItems: 'center', justifyContent: 'end' }}
                    >
                        <img
                            src={Enamad}
                            alt="Enamad"
                            style={{ cursor: "pointer", height: '100%', width: 'auto', maxHeight: '144px', display: 'block' }}
                            code='lpcM4Lnx6MYjfARckKsZYvDWyQcovZDS'
                        />
                    </a>
                    <img 
                        src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQwIiBoZWlnaHQ9IjM2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KCTxwYXRoIGQ9Im0xMjAgMjQzbDk0LTU0IDAtMTA5IC05NCA1NCAwIDEwOSAwIDB6IiBmaWxsPSIjODA4Mjg1Ii8+Cgk8cGF0aCBkPSJtMTIwIDI1NGwtMTAzLTYwIDAtMTE5IDEwMy02MCAxMDMgNjAgMCAxMTkgLTEwMyA2MHoiIHN0eWxlPSJmaWxsOm5vbmU7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDo1O3N0cm9rZTojMDBhZWVmIi8+Cgk8cGF0aCBkPSJtMjE0IDgwbC05NC01NCAtOTQgNTQgOTQgNTQgOTQtNTR6IiBmaWxsPSIjMDBhZWVmIi8+Cgk8cGF0aCBkPSJtMjYgODBsMCAxMDkgOTQgNTQgMC0xMDkgLTk0LTU0IDAgMHoiIGZpbGw9IiM1ODU5NWIiLz4KCTxwYXRoIGQ9Im0xMjAgMTU3bDQ3LTI3IDAtMjMgLTQ3LTI3IC00NyAyNyAwIDU0IDQ3IDI3IDQ3LTI3IiBzdHlsZT0iZmlsbDpub25lO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6MTU7c3Ryb2tlOiNmZmYiLz4KCTx0ZXh0IHg9IjE1IiB5PSIzMDAiIGZvbnQtc2l6ZT0iMjVweCIgZm9udC1mYW1pbHk9IidCIFlla2FuJyIgc3R5bGU9ImZpbGw6IzI5Mjk1Mjtmb250LXdlaWdodDpib2xkIj7Yudi22Ygg2KfYqtit2KfYr9uM2Ycg2qnYtNmI2LHbjDwvdGV4dD4KCTx0ZXh0IHg9IjgiIHk9IjM0MyIgZm9udC1zaXplPSIyNXB4IiBmb250LWZhbWlseT0iJ0IgWWVrYW4nIiBzdHlsZT0iZmlsbDojMjkyOTUyO2ZvbnQtd2VpZ2h0OmJvbGQiPtqp2LPYqCDZiCDaqdin2LHZh9in24wg2YXYrNin2LLbjDwvdGV4dD4KPC9zdmc+ " 
                        alt="" 
                        onClick={handleClickMajazi}
                        style={{cursor: "pointer", width: '96px', height: '144px'}} />
                </div>


            </footer>
        </div>

    );
}

export default Main;